import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {LmLeadDto} from "../../../model/dto/entity/lm-lead.dto";
import {LmLeadService} from "../../../service/api/lm-lead.service";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {ObjectTypeService} from "../../../../../core/cc/service/api/object-type.service";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectRequestComplex} from "../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../core/shared/dto/object/request/object-request-complex-node";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {LmEntityStatusEnum} from "../../../enum/lm-entity-status.enum";
import {EntityStatusEnum} from "../../../../../core/shared/entity/enum/entity-status.enum";

/**
 * Used
 */
@Component({
    selector: 'lm-lead-inline-component',
    templateUrl: 'lm-lead-inline-component.html',
    standalone: false,
})
export class LmLeadInlineComponent implements OnInit, OnChanges {

    @Input() objectIdentifier: ObjectIdentifier;
    @Input() importObjectContext: DtoImportObjectContext;
    @Input() size: string = 'M';

    icon: string;
    leadDto: LmLeadDto;

    initialized: boolean;
    busy: boolean;

    constructor(
        protected leadService: LmLeadService,
        protected navigationService: MvsObjectNavigationService,
        protected objectService: ObjectTypeService) {
    }

    ngOnInit() {
        this.initComponent();
    }

    initComponent() {
        this.icon = this.leadService.getObjectIcon();
        this.refreshComponent();

    }

    refreshComponent() {

        const filterCriteria = FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        const objectRequestList = ObjectRequestList.createBasic(false, [filterCriteria], []);
        objectRequestList.objectRequestComplex = ObjectRequestComplex.build(true, false, ObjectRequestComplexNode.createSimpleAttributeNode('person'))

        this.leadService.list(objectRequestList).subscribe((res: DtoList<LmLeadDto>) => {
            this.leadDto = res.entries[0];
            this.initialized = true;
        });
    }

    handleClick() {
        const navigationEntry = MvsObjectNavigationEntry.createNavigationEntry(this.objectIdentifier.objectType, this.objectIdentifier.objectId, null, this.objectIdentifier.objectType, null, null, MvsObjectNavigationActionEnum.any);
        // this.navigationService.openObjectInNewTab(navigationEntry)
    }

    ngOnChanges(changes: SimpleChanges) {

        if (!this.initialized) {
            return;
        }

        if (changes.objectIdentifier || changes.restrictedCustomer) {
            this.refreshComponent();
        }

    }

    protected readonly EntityStatusEnum = EntityStatusEnum;
    protected readonly LmEntityStatusEnum = LmEntityStatusEnum;
}
